// extracted by mini-css-extract-plugin
export default {"image":"NoContent_image__pl7Zi"};